import styled from "styled-components";

import { Flex } from "@similarweb/ui-components/foundations";

export const StyledScoringSettingsPage = styled.div`
    height: auto;
    padding-bottom: 50px;
    margin: 0 auto;
    max-width: 1366px;
    width: 100%;
`;

export const StyledScoringSettingsInnerContainer = styled(Flex)`
    height: 100%;
    padding: 32px 40px 0 40px;
`;
